export default __webpack_public_path__ + "static/media/own-prompt.9045fec9.svg";